import { ProjectModuleWellConnectSurfaceEquipmentBase } from './base/project-module-well-connect-surface-equipment-base';

export class ProjectModuleWellConnectSurfaceEquipment extends ProjectModuleWellConnectSurfaceEquipmentBase { }